import onShareIdPresent from './action/on-share-id';
import urlFirstPath from './url/first-path';
import displayText from './dom/display-text';
import errorMessage from './error/message';
import ExtendedError from './error/type/Extended';
import { AdoptMessageEvent } from './message/type/AdoptMessageEvent';
import { ShareLinkMessengerMessage } from './message/type/ShareLinkMessengerMessage';
import handleMessage from './message/handle';

(async () => {
    try {
        const shareId = urlFirstPath() as string;

        if (shareId) {
            await onShareIdPresent(shareId);
            return;
        }

        window.addEventListener(
            'message',
            (message: AdoptMessageEvent<ShareLinkMessengerMessage>) => handleMessage(message.data)
        );
    } catch (e) {
        displayText(errorMessage(e as ExtendedError));
    }
})();

export default {};
